import { Component, OnInit } from '@angular/core';
import { RoutingPath } from 'src/app/configs/routing-path';

@Component({
    selector: 'app-vertical-shortcuts',
    templateUrl: './vertical-shortcuts.component.html',
    styleUrls: ['./vertical-shortcuts.component.scss'],
    standalone: false
})
export class VerticalShortcutsComponent implements OnInit {

  title = 'Accesos rápidos';
  shortcuts = [];
  constructor() {
    let comp = RoutingPath.appRouting.components;

    this.shortcuts = [
      {
        name: 'Afiliar trabajador',
        icon: 'person_add',
        routerLink: '/' + comp.invidivual_affiliation.path + '/' + comp.invidivual_affiliation.pages.home.path,
      },
      {
        name: 'Afiliación masiva',
        icon: 'group_add',
        routerLink: '/' + comp.mass_affiliation.path + '/' + comp.mass_affiliation.pages.home.path,
      },
      {
        name: 'Certificado afiliación',
        icon: 'archive',
        routerLink: '/' + comp.certificates.path + '/' + comp.certificates.pages.consult_worker.path,
        queryParams: {
          id: 'trabajador'
        }
      },
      {
        name: 'Trabajadores',
        icon: 'people',
        routerLink: '/' + comp.workers_information.path + '/' + comp.workers_information.pages.consult_worker.path,
      }
    ];
  }

  ngOnInit() {
  }

}
